'use strict';

var EFC = window.EFC = (window.EFC || {});
EFC.Track = (function($) {
  function init() {
    $('.resource__download-link, .resource__view-link ').on('click', function() {
      const title = this.closest('[data-resource-title]').dataset.resourceTitle;
      const categoryType = this.classList.contains('resource__download-link') ? 'download' : 'view';
      
      window.ga && window.ga('send', 'event', 'resource-' + categoryType, title);
    });

    $('a.button[href*="wp-content/uploads"]').on('click', function() {
      const href = this.getAttribute('href');
      const filename = href.replace(/.*\/([^\/]*)/, '$1');
      window.ga && window.ga('send', 'event', 'file-download', filename);
    });
  }
    
  $(init);  
})(jQuery);